/* ==========================================================================
   Maison Romaan — bottle fill scroll animation
   Used by sections/bottle-fill-animation.liquid
   Scoped to a single instance via the wrapper's data-section-id, so it's
   safe even if the section is duplicated on the page.
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-mr-bottle-track]').forEach(initBottleAnimation);
});

// Re-init when the section is added/edited live in the theme editor
document.addEventListener('shopify:section:load', function (event) {
  var track = event.target.querySelector('[data-mr-bottle-track]');
  if (track) initBottleAnimation(track);
});

function initBottleAnimation(track) {
  if (track._mrInitialized) return;
  track._mrInitialized = true;

  var root = track.closest('[data-mr-bottle-section]') || track;
  var assembleStage = root.querySelector('[data-mr-stage]');
  var assembleBottle = root.querySelector('[data-mr-bottle]');
  var liquidRect = root.querySelector('[data-mr-liquid]');
  var labelGroup = root.querySelector('[data-mr-label]');
  var capGroup = root.querySelector('[data-mr-cap]');
  var shineBar = root.querySelector('[data-mr-shine]');
  var ingEls = Array.prototype.slice.call(root.querySelectorAll('[data-mr-ingredient]'));

  if (!assembleStage || !assembleBottle || !liquidRect) return;

  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  var LIQUID_TOP = 203, LIQUID_BOTTOM = 488, LIQUID_FULL_H = LIQUID_BOTTOM - LIQUID_TOP;
  var START_FILL = 0.10;
  var LAND_START = 0.74, LAND_END = 0.84;
  var shineFired = false;

  function cacheIngredientPositions() {
    if (assembleStage.offsetParent === null) return;
    ingEls.forEach(function (el) { el.style.transform = 'translate(0,0) scale(1)'; });
    void assembleStage.offsetHeight; // force reflow
    var bRect = assembleBottle.getBoundingClientRect();
    var targetX = bRect.left + bRect.width * 0.5;
    var targetY = bRect.top + bRect.height * 0.62;
    ingEls.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var ox = r.left + r.width / 2, oy = r.top + r.height / 2;
      el._dx = targetX - ox;
      el._dy = targetY - oy;
    });
  }

  function getProgress() {
    if (track.offsetParent === null) return 0;
    var rect = track.getBoundingClientRect();
    var scrollable = track.offsetHeight - window.innerHeight;
    if (scrollable <= 0) return 0;
    return clamp(-rect.top / scrollable, 0, 1);
  }

  function triggerShine() {
    if (!shineBar) return;
    shineBar.style.transition = 'none';
    shineBar.setAttribute('transform', 'translate(-260,-340) rotate(35)');
    void shineBar.getBoundingClientRect();
    shineBar.style.transition = 'transform .7s ease';
    shineBar.setAttribute('transform', 'translate(300,420) rotate(35)');
  }

  var bobStart = null;
  function bobLoop(timestamp) {
    if (bobStart === null) bobStart = timestamp;
    var t = timestamp - bobStart;
    var progress = getProgress();
    var landP = clamp((progress - LAND_START) / (LAND_END - LAND_START), 0, 1);

    if (capGroup) {
      var floatY = -34 * (1 - landP);
      var bob = (1 - landP) > 0.02 ? Math.sin(t / 650) * 5 : 0;
      capGroup.setAttribute('transform', 'translate(0, ' + (floatY + bob).toFixed(2) + ')');
    }

    if (landP >= 1 && !shineFired) {
      shineFired = true;
      triggerShine();
    }
    if (landP < 1) shineFired = false;

    requestAnimationFrame(bobLoop);
  }
  requestAnimationFrame(bobLoop);

  function updateAssemble() {
    var progress = getProgress();
    var stageCount = ingEls.length || 1;
    var ingSpan = 0.7 / stageCount;

    ingEls.forEach(function (el, i) {
      var segStart = i * ingSpan;
      var p = clamp((progress - segStart) / ingSpan, 0, 1);
      var dx = el._dx || 0, dy = el._dy || 0;
      el.style.transform = 'translate(' + (dx * p) + 'px, ' + (dy * p) + 'px) scale(' + (1 - 0.7 * p) + ')';
      el.style.opacity = p < 1 ? (1 - p * 0.15) : 0;
    });

    var fillProgress = clamp(progress / 0.7, 0, 1);
    var fillFraction = START_FILL + (1 - START_FILL) * fillProgress;
    var h = LIQUID_FULL_H * fillFraction;
    liquidRect.setAttribute('height', h.toFixed(1));
    liquidRect.setAttribute('y', (LIQUID_BOTTOM - h).toFixed(1));

    if (labelGroup) {
      var labelP = clamp((progress - 0.8) / 0.16, 0, 1);
      labelGroup.style.opacity = labelP;
    }
  }

  window.addEventListener('scroll', updateAssemble, { passive: true });
  window.addEventListener('resize', function () { cacheIngredientPositions(); updateAssemble(); });
  window.addEventListener('load', function () { cacheIngredientPositions(); updateAssemble(); });
  setTimeout(function () { cacheIngredientPositions(); updateAssemble(); }, 200);
}
